export default __webpack_public_path__ + "static/media/plus-white.c06c1001.svg";